class SystemPayRoutes {
  public static base = "";
  public static landing = `${this.base}/landing`;

  //auth
  public static signIn = `${this.base}/sign-in`;
  public static forgotPassword = `${this.base}/forgot-password`;

  //reports
  public static reports = `${this.base}/reports`;
  public static reportsTypeBase = `${this.reports}/:type`;
  public static reportsType = `${this.reportsTypeBase}/:id`;
  public static reportBase = `${this.base}/report`;
  public static report = `${this.reportBase}/:id`;
  public static foundReportBase = `${this.reportBase}/found`;
  public static foundReport = `${this.foundReportBase}/:id`;

  public static foundedReport = `/founded-reports`;
  public static foundedReports = `${this.base}${this.foundedReport}`;
  public static foundedItemReports = `${this.base}/found-item-report`;

  public static customers = `${this.base}/customers`;

  //pricingPlan
  public static pricingPlan = `${this.base}/pricing-plan`;

  //category
  public static category = `${this.base}/category`;
  public static addCategory = `${this.category}/add`;
  public static editCategory = `${this.category}/edit/:id`;

  //sub-category
  public static subCategory = `${this.base}/sub-category`;
  public static addSubCategory = `${this.subCategory}/add`;
  public static editSubCategory = `${this.subCategory}/edit/:id`;

  //category-option
  public static question = `${this.base}/question`;
  public static addQuestion = `${this.question}/add`;
  public static editQuestion = `${this.question}/edit/:id`;

  //shopping--box
  public static shoppingBoxType = `${this.base}/shopping-box-type`;
  public static addShoppingBoxType = `${this.shoppingBoxType}/add`;
  public static editShoppingBoxType = `${this.shoppingBoxType}/edit/:id`;

  //user-role configuration
  public static userRoleConfiguration = `${this.base}/user-role-configuration`;

  //user
  public static Users = `${this.base}/users`;

  //logs
  public static activityLogs = `${this.base}/activity`;
  public static emailLogs = `${this.base}/email`;
  public static ship = `${this.base}/ship`;
  public static airport = `${this.base}/airport`;
  public static establishmentType = `${this.base}/establishmentType`;
  public static shippingBoxType = `${this.base}/shipping-box-type`;
  public static location = `${this.base}/location`;
  public static payment = `/payment`;
  public static paymentLogs = `${this.base}/${this.payment}`;

  //Lost Reason
  public static deleteReason = `${this.base}/delete-reason`;

  //Discard Found Reason
  public static discardFoundReason = `/discard-found-reason`;
  public static foundItemDiscardReason = `${this.base}/${this.discardFoundReason}`;

  //Email Template
  public static mailTemplate = `${this.base}/mail-template`;

  //Profile
  public static profile = `${this.base}/profile`;

  //Settings
  public static keysAndSettings = `${this.base}/keys-and-settings`;


  //Courier
  public static courier = `${this.base}/courier`;

  //Courier Shipping Options
  public static courierShippingOptions = `${this.base}/courier-shipping-options`;

  //Permission Key
  public static permissionKey = `${this.base}/permission-key`;

  //Ship From Port
  public static shipFromPort = `${this.base}/ship-from-port`;

  //Whiteboard
  public static whiteboard = `${this.base}/whiteboard`;

  //Reviews
  public static reviews = `${this.base}/reviews`;

  //Conversion Tracking
  public static conversionTracking = `${this.base}/conversion-tracking`;
}

export default SystemPayRoutes;
